import http from "../../http";

const BASE = "/gateway/syinfopublish/api/pc/information/question";
const CMS_V2 = "/gateway/syinfopublish/api/pc/information/v2";

/**
 * 问卷运营：采集台 / 记录相关（与 informationQuestion 编辑 CRUD 分离）
 */
const informationQuestionOps = {
  selectQuestionUserPage(param) {
    return http.spin.get(`${BASE}/selectQuestionUserPage`, param);
  },
  queryDynamicFormDataPage(param) {
    return http.spin.payload(`${BASE}/queryDynamicFormDataPage`, param);
  },
  selectDistinctDynamicFormDataPage(param) {
    return http.spin.payload(`${BASE}/selectDistinctDynamicFormDataPage`, param);
  },
  downloadDynamicForm(param) {
    return http.spin.payload(`${BASE}/downloadDynamicForm`, param);
  },
  getAllHeads(param) {
    return http.payload(`${BASE}/getAllHeads`, param);
  },
  downloadDynamicFormCustom(param) {
    return http.spin.payload(`${BASE}/downloadDynamicFormCustom`, param);
  },
  deleteRecordById(param) {
    return http.spin.post(`${BASE}/deleteRecordById`, param);
  },
  /** 采集分析：走 CMS v2（入参 informationId） */
  selectAcquisitionAnalysis(param) {
    return http.get(`${CMS_V2}/selectAcquisitionAnalysis`, param);
  },
  /** 表头：走 CMS v2（入参 informationId） */
  selectDynamicFormHeader(param) {
    return http.get(`${CMS_V2}/selectDynamicFormHeader`, param);
  },
};

export default informationQuestionOps;
